import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import { Notification } from '@telus-uds/components-web';

import request from '../../../../utils/request';
import { EditContainer, EditInput } from '../css';

const Edit = ({ id, name, mode, setMode, fetchData }) => {
  const [domainName, setDomainName] = useState(name);
  const [validationError, setValidationError] = useState(false);

  const updateDomainName = async () => {
    if (!domainName || name === domainName) {
      setValidationError(true);
      return;
    }
    try {
      const result = await request.post(`/domains/${id}`, {
        name: domainName
      });

      if (result && result.status === 200) {
        setMode({ ...mode, edit: false });
        fetchData();
      }
    } catch (err) {
      setMode({ ...mode, edit: false });
      throw err;
    }
  };

  return (
    <EditContainer>
      <EditInput
        type="text"
        value={domainName}
        onChange={e => setDomainName(e.target.value)}
      />
      <Button type="button" onPress={updateDomainName}>
        Update
      </Button>
      <Button
        variant={{ priority: 'low' }}
        type="button"
        onPress={() => setMode({ ...mode, edit: false })}
      >
        Cancel
      </Button>
      {validationError && (
        <Notification
          variant={{ validation: 'error' }}
          dismissible
          onExit={() => setValidationError(false)}
          copy="en"
        >
          Please make sure the dealership name is not empty or same as before
        </Notification>
      )}
    </EditContainer>
  );
};

Edit.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  mode: PropTypes.shape({ edit: PropTypes.bool, delete: PropTypes.bool })
    .isRequired,
  setMode: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default Edit;
